import cookie from "cookie";
import { DateTime } from "luxon";

const setAccessToken = (access_token: any) => {
  return cookie.serialize("access_token", access_token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === "development",
    maxAge: 60 * 60 * 24 * 365,
    sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
    domain: process.env.NEXT_PUBLIC_COOKIE_URL,
    path: "/",
  });
};
const loginDateIST = DateTime.now()
  .setZone("Asia/Kolkata")
  .toFormat("yyyy-MM-dd");

const setLoginDateCookie = cookie.serialize("login_date", loginDateIST, {
  httpOnly: true,
  secure: process.env.NODE_ENV === "development",
  maxAge: 60 * 60 * 24, // 1 day
  sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
  domain: process.env.NEXT_PUBLIC_COOKIE_URL,
  path: "/",
});
const set2faDateCookie = cookie.serialize("2fa_verified_date", loginDateIST, {
  httpOnly: true,
  secure: process.env.NODE_ENV === "development",
  maxAge: 60 * 60 * 24, // 1 day
  sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
  domain: process.env.NEXT_PUBLIC_COOKIE_URL,
  path: "/",
});

const clearLoginDateCookie = cookie.serialize("login_date", "", {
  path: "/",
  httpOnly: true,
  sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
  secure: process.env.NODE_ENV === "development",
  domain: process.env.NEXT_PUBLIC_COOKIE_URL,
  expires: new Date(0),
});
const clear2faDateCookie = cookie.serialize("2fa_verified_date", "", {
  path: "/",
  httpOnly: true,
  sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
  secure: process.env.NODE_ENV === "development",
  domain: process.env.NEXT_PUBLIC_COOKIE_URL,
  expires: new Date(0),
});

const removeAccessToken = () => {
  try {
    /* we can clear local storage here */
    console.log("removeAccessToken-called");
    return cookie.serialize("access_token", "", {
      httpOnly: true,
      secure: process.env.NODE_ENV === "development",
      maxAge: 0,
      sameSite: process.env.NODE_ENV === "development" ? "none" : "strict",
      domain: process.env.NEXT_PUBLIC_COOKIE_URL,
      path: "/",
      expires: new Date(),
    });
  } catch (error) {
    console.log("removeAccessToken-error", error);
  }
};

export {
  setAccessToken,
  removeAccessToken,
  setLoginDateCookie,
  set2faDateCookie,
  clearLoginDateCookie,
  clear2faDateCookie,
};
